import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { InlineErrors } from './sub-components/inline-errors';
import { FieldTitle } from './sub-components/field-title';
import {
  vFParamsPropShape,
  vFSingleRadioDisplayOptionsShape,
  disabledFieldOptionsShape,
} from './data-structure/v-f-proptypes';
import {
  getFieldPropShape,
  formPropShape,
} from './data-structure/formik-proptypes';
import 'AppSrc/core/style/components/form/form-base-components/v-f-single-radio.css';


class VFSingleRadio extends PureComponent {
  constructor(props) {
    super(props);
    this.updateValue = this.updateValue.bind(this);
    this.setTouched = this.setTouched.bind(this);
    this.setValue = this.setValue.bind(this);
  }

  componentDidMount() {
    this.ifDisabledSetDefaultValues({});
  }

  componentDidUpdate(prevProps) {
    this.ifDisabledSetDefaultValues({
      prevProps,
    });
  }

  setTouched() {
    const {
      field,
    } = this.props;

    const {
      name,
    } = field;

    this.props.form.setFieldTouched(name, true);
  }

  setValue(valueToUpdate) {
    const {
      field,
      displayOptions,
      vFParams,
      form,
    } = this.props;


    const {
      formatCurrentValue,
    } = vFParams;

    const {
      name,
    } = field;

    const simplifiedValue = formatCurrentValue ? formatCurrentValue({
      value: valueToUpdate,
      displayOptions,
    }) : valueToUpdate;

    form.setFieldValue(name, simplifiedValue);
    form.setFieldTouched(name, true);
  }

  updateValue(valueToUpdate) {
    const { field } = this.props;
    const { value } = field;

    if (value === valueToUpdate) {
      this.setValue(null);
      return null;
    }

    this.setValue(valueToUpdate);
    return null;

  }

  ifDisabledSetDefaultValues(params) {
    const {
      prevProps,
    } = params;
    const {
      name,
      value,
    } = this.props.field;
    const {
      disabled,
      disabledValue,
      unDisabledValue,
    } = this.props.disabledFieldOptions;
    // check if the previous props had set it to disabled
    const prevDisabled = prevProps ? prevProps.disabledFieldOptions.disabled : false;

    if (!disabled) {
      if (prevDisabled) {
        this.props.form.setFieldValue(name, unDisabledValue);
        this.props.form.setFieldTouched(name, true);
      }
      return null;
    }

    if (JSON.stringify(value) !== JSON.stringify(disabledValue)) {
      this.props.form.setFieldValue(name, disabledValue);
      this.props.form.setFieldTouched(name, true);
    }
    return null;
  }

  render() {

    const {
      vFParams,
      displayOptions,
      field,
      form,
      disabledFieldOptions,
      optional,
      readOnly,
    } = this.props;

    const {
      name,
      value,
    } = field;

    const {
      disabled,
    } = disabledFieldOptions;

    const formErrors = form.errors;
    const touched = form.touched[name];


    const errors = formErrors[name];

    const inlineErrors = errors && errors.inlineErrors ? errors.inlineErrors : null;

    const {
      fieldTitle,
    } = vFParams;

    // const className = `v-f-field-type v-f-single-radio${disabled ? ' v-f-single-radio-disabled' : ''}${readOnly ? ' v-f-single-radio-read-only' : ''} v-f-single-radio-${name}`;
    const className = `v-f-field-type v-f-single-radio v-f-single-radio-${name}`;

    return (
      <div
        className={className}
        name={name}
      >
        {
          fieldTitle && (
            <FieldTitle
              fieldTitle={fieldTitle}
              optional={optional}
            />
          )
        }
        <div className="v-f-single-radio-group">
          {
            displayOptions.map((displayOption) => {
              const isSelected = value === displayOption.value;
              const id = `${name}-${value}`;
              const LabelComponent = displayOption.label;
              return (
                <div className="v-f-single-radio-wrapper" key={displayOption.value}>
                  <label htmlFor={id}>
                    {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                    <LabelComponent text={displayOption.text} />
                  </label>
                  <input
                    className="v-f-single-radio"
                    type="radio"
                    id={id}
                    name={name}
                    checked={isSelected}
                    onBlur={this.setTouched}
                    onChange={() => this.updateValue(displayOption.value)}
                    disabled={disabled || readOnly}
                  />
                </div>
              );
            })
          }
        </div>
        {
          inlineErrors && touched && (
            <InlineErrors
              inlineErrors={inlineErrors}
            />
          )
        }
      </div>
    );
  }
}



VFSingleRadio.propTypes = {
  vFParams: vFParamsPropShape,
  displayOptions: PropTypes.arrayOf(vFSingleRadioDisplayOptionsShape),
  // we have to define the value within the data structure for field
  field: getFieldPropShape(PropTypes.any),
  form: formPropShape,
  disabledFieldOptions: disabledFieldOptionsShape,
  optional: PropTypes.bool,
  readOnly: PropTypes.bool,
};


const noValueVFSingleRadio = (value) => !value;


// This is a reference to the component. This is needed as the value for each form field is displayed on a change summary
// page but this is dependant on what type of form field is used
const VF_SINGLE_RADIO = 'v-f-single-radio';

export {
  VFSingleRadio,
  noValueVFSingleRadio,
  VF_SINGLE_RADIO,
};
